/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_LendingInputs */



/**
* | output |
* | --- |
* | "Lending" |
*
* @param {Nav_LendingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_lending = /** @type {((inputs?: Nav_LendingInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_LendingInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verleih")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Prêts")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("借出")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("借卡")
	if (locale === "ko") return /** @type {LocalizedString} */ ("대여")
	return /** @type {LocalizedString} */ ("Lending")
});